import { render, staticRenderFns } from "./ConfiguracoesEmailPesquisa.vue?vue&type=template&id=7ba28bdc&"
import script from "./ConfiguracoesEmailPesquisa.vue?vue&type=script&lang=js&"
export * from "./ConfiguracoesEmailPesquisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports